// Product ID to single Variant ID mapping
let tangent_selected_product_map;
let default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";
let tangent_recommended_products;
let market;

let tangent_client_domain_currency;
// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};


// Add default image url here
const tangent_default_selfie_image_url= "https://cdn.shopify.com/s/files/1/0272/6048/5711/files/scalp_care.jpg?v=1772626280";

const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", (event) => {
    onLoadFunction();
  });
} else {
  onLoadFunction();
}

function onLoadFunction(){
  var tangent_response_id = getClientResponseId()
  checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  let tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    market = document.getElementById("tangent-shop-market").value;
    const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true&market="+market;
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    tangent_recommended_products = response.products;
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);

      // Used for spider chart creation
    if(response["selfie_id"]!=null){
      getSelfieMapping(response);
      setElementDisplay("section_chart_container","flex");
    }
  
    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
      setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
      enableButtonListener();
      loadElementsOnResponseData();  
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
}


function getSelfieMapping(response){
  const selfie_id = response.selfie_id
  setSelfieHairType(response.tags);  
   var selfie_api_url = "https://service.tangent.ai/shopify/upload-selfie?selfie_id="+selfie_id+"&user=mango"
   var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        var DONE =  (typeof XMLHttpRequest.DONE !== 'undefined') ? XMLHttpRequest.DONE : 4;
        if (xmlhttp.readyState == DONE) { 
            if (xmlhttp.status == 200) {
              var response_json = JSON.parse(xmlhttp.responseText);
              drawChart(response_json);
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", selfie_api_url, true);
    xmlhttp.send();
}


function drawChart(params) {
  const attributeNames = ["Dryness", "Frizz", "Split Ends", "Shine", "Flyaways"];
  var selfie_conditions = params?.selfie_record[0]?.hairdamage?.attributes;
  if(selfie_conditions){
    var attr_list = [];
    for (const attributeName of attributeNames){
        attr_list.push({
            "x": attributeName.toUpperCase(),
            "value": getAttributeScore(selfie_conditions, attributeName)
        });
    }
    // create a chart
    drawRadarChart(attr_list);
  }
}
function getAttributeScore(attributeMap, attributeName, minimum=0.2){
   if(attributeMap.hasOwnProperty(attributeName)){
      return attributeMap[attributeName].score; 
    }
    return 1;
}

function drawRadarChart(list){
  setElementDisplay("chart-loading-section","none");
  var chart = anychart.radar();
  var interactivity = chart.interactivity();
  interactivity.hoverMode("bySpot");
  interactivity.spotRadius(0);

  chart.tooltip(false);
  chart.yScale().ticks().interval(1);
  chart.yScale().minimum(0);
  chart.yScale().maximum(5);
  chart.area(list).fill("rgba(199, 190, 226, 0.4)").stroke("rgba(121, 105, 171, 1)");


  var labels = chart.yAxis().labels();
  labels.enabled(false);
  chart.labels().fontFamily("Futura");
  chart.container("graph_container");
  chart.draw();
}

function setSelfieHairType(tags) {
  const el = document.getElementById("skin-type-text");

  const typeMap = {
    "1": "Straight",
    "2": "Wavy",
    "3": "Curly",
    "4": "Coily"
  };

  const subtypeOrder = {
    "2": ["2a", "2b", "2c"],
    "3": ["3a", "3b", "3c"],
    "4": ["4a", "4b", "4c"]
  };

  const normalized = tags.map(t => t.toLowerCase());

  let category = null;
  let subTypes = [];

  for (let key of ["1", "2", "3", "4"]) {
    if (normalized.some(t => t.startsWith(key))) {
      category = key;
      if (subtypeOrder[key]) {
        subTypes = normalized.filter(t => subtypeOrder[key].includes(t));
        subTypes.sort((a, b) => subtypeOrder[key].indexOf(a) - subtypeOrder[key].indexOf(b));
      }
      break;
    }
  }

  if (!category) {
    if (normalized.includes("straight")) category = "1";
    else if (normalized.includes("wavy")) category = "2";
    else if (normalized.includes("curly")) category = "3";
    else if (normalized.includes("coily")) category = "4";
  }

  // 🔹 Step 3: Show result
  if (category) {
    const subtypeText = subTypes.length ? ` (${subTypes.join(", ")})` : "";
    el.innerHTML = `Your hair type is ${typeMap[category]}${subtypeText}`;
  } else {
    el.innerHTML = "No hair type detected.";
  }
}


function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};

  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");

    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();

    for (const id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          if(product.publishedInContext){
            const variant = getSelectedVariant(product, selected_variants[product.id]);
              
            let isAvailable = isProductAvailable(product, variant);

            if(isAvailable){
              // Track selected product variant
              tangent_selected_product_map[product.id] = extractVariantId(variant.id);
              // Generate product HTML and append it to the fragment
              const product_html = getProductHTML(product, p, variant, section, sections);

              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = product_html;

              // Append the created product HTML to the fragment
              while (tempDiv.firstChild) {
                fragment.appendChild(tempDiv.firstChild);
              }
            }
            else{
              console.log("product not available", product.title);
            }
          }
        }
      }
    }

    // Append the fragment to the DOM in one go
    product_section_grid.appendChild(fragment);
  });
}
function extractVariantId(gid) {
  if (!gid) return null;
  return gid.split('/').pop();
}

function getSelectedVariant(product, variant_list) {

  const productVariants = product?.variants?.edges || [];

  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }

  const variants = productVariants.map(edge => edge.node);

  if (variant_list && variant_list.length > 0) {

    const selectedVariantId = String(variant_list[0]);

    const selectedVariant = variants.find(variant =>
      extractVariantId(variant.id) === selectedVariantId
    );

    if (selectedVariant) {
      return selectedVariant;
    }
  }

  return variants[0];
}

function getProductHTML(product, index, variant, section, sections) {

  const variantId = extractVariantId(variant.id);
  const variantImageUrl = getVariantImage(variant.image, product);

  const variantProductUrl = `${product.onlineStoreUrl}?variant=${variantId}`;

  let variantTitle = variant.title === "Default Title" ? "" : variant.title;

  let buttonText = default_addToCartText;
  let buttonClass = "";
  const isAvailable = isProductAvailable(product, variant);
  
  // Hardcoded section to maintain one global "Add All To Cart"
  updateSectionAllToCartLink(
    "section_all_products",
    tangent_selected_product_map[product.id]
  );

  return `
    <div class="tangent-product-card">

      <div id="tangent-image-product-card">
        <a 
          id="url_tangent_product_${index}"
          class="tangent-text-link"
          target="_blank"
          href="${variantProductUrl}"
        >
          <img 
            id="image_tangent_product_${index}"
            src="${variantImageUrl}"
            class="tangent_product_image"
            alt="${escapeHTML(product.title)}"
          >
        </a>

        <button
          class="tangent-product-add-btn-wrapper tangent_add_to_cart_button ${buttonClass} show-on-laptop-only"
          id="${variantId}"
          type="button"
          ${!isAvailable ? "disabled" : ""}
        >
          ${buttonText}
        </button>

      </div>

      <p class="tangent-product-title tangent_product_title_text">
        ${escapeHTML(product.title)}
      </p>

      <p 
        id="price_tangent_product_${index}"
        class="tangent_product_price_text"
      >
        ${tangent_client_domain_currency}${variant.price}
      </p>

      <p class="tangent_variant_title">
        ${escapeHTML(variantTitle)}
      </p>

      ${appendVariantsIfMultiple(product, variantId)}

      <button
        class="tangent-product-add-btn-wrapper tangent_add_to_cart_button ${buttonClass} show-on-mobile-only"
        id="${variantId}"
        type="button"
        ${!isAvailable ? "disabled" : ""}
      >
        ${buttonText}
      </button>

    </div>
  `;
}

function appendVariantsIfMultiple(product, selectedVariantId) {

  const variants = product?.variants?.edges?.map(v => v.node) || [];

  if (variants.length <= 1) return "";

  let html = `<div class="tangent-variant-wrapper" data-product-id="${product.id}">`;

  variants.forEach((variant) => {

    const variantId = extractVariantId(variant.id);

    const selectedClass = variantId == selectedVariantId ? "active" : "";

    html += `
      <div 
        class="tangent-variant-option ${selectedClass}" 
        data-product-id="${product.id}"
        data-variant-id="${variantId}"
        onclick="onVariantClick(this)"
      >
        ${variant.title}
      </div>
    `;
  });

  html += `</div>`;

  return html;
}

function getPreviousVariantId(wrapper){
  const previousActive = wrapper.querySelector(".tangent-variant-option.active");
  return previousActive ? previousActive.dataset.variantId : null;
}

function highlightVariant(wrapper, element){
  wrapper.querySelectorAll(".tangent-variant-option").forEach(opt=>{
    opt.classList.remove("active");
  });
  element.classList.add("active");
}

function getProductAndVariant(productId, variantId) {

  const product = tangent_recommended_products.find(
    p => String(p.id) === String(productId)
  );

  if (!product) return {};

  const variants = product?.variants?.edges?.map(v => v.node) || [];

  const variant = variants.find(
    v => String(extractVariantId(v.id)) === String(variantId)
  );

  return { product, variant };
}

function updateVariantTitle(productCard, variant){
  const titleEle = productCard.querySelector(".tangent_variant_title");
  if(titleEle){
    titleEle.innerText = variant.title;
  }
}

function updatePrice(productCard, variant){
  const priceEle = productCard.querySelector(".tangent_product_price_text");
  if(priceEle){
    priceEle.innerText = `$${variant.price}`;
  }
}

function updateCartButtons(productCard, variantId){
  const cartButtons = productCard.querySelectorAll(".tangent_add_to_cart_button");
  cartButtons.forEach(btn=>{
    btn.id = variantId;
  });
}

function updateProductUrl(productCard, product, variantId){
  const productLink = productCard.querySelector(".tangent-text-link");
  if(productLink){
    productLink.href = `https://curlwarehouse.com/products/${product.handle}?variant=${variantId}`;
  }
}

function updateProductImage(productCard, product, variant) {
  const imageEle = productCard.querySelector(".tangent_product_image");
  if (!imageEle) return;

  // default product image
  let imageSrc = product?.images?.nodes?.[0]?.url;

  // variant image override
  if (variant?.image?.url) {
    imageSrc = variant.image.url;
  }

  if (imageSrc) {
    imageEle.src = imageSrc;
  }
}

function updateSectionCartMap(previousVariantId, variantId){

  const sectionName = "section_all_products";
  const section = sections_add_to_cart_map[sectionName];

  if(!section || !previousVariantId) return;

  const index = section.list.findIndex(
    id => String(id) === String(previousVariantId)
  );

  if(index !== -1){
    section.list[index] = variantId;
  }

  rebuildCartLink(section);
}

function rebuildCartLink(section){

  const params = section.list
    .map(id => `items[][id]=${id}&items[][quantity]=1`)
    .join("&");

  section.cart_link = `${tangent_client_domain_url}/cart/add?${params}`;
}

function onVariantClick(element){

  const wrapper = element.closest(".tangent-variant-wrapper");
  const productCard = element.closest(".tangent-product-card");

  const variantId = element.dataset.variantId;
  const productId = element.dataset.productId;

  const previousVariantId = getPreviousVariantId(wrapper);

  highlightVariant(wrapper, element);

  const { product, variant } = getProductAndVariant(productId, variantId);
  if(!product || !variant) return;

  updateVariantTitle(productCard, variant);
  updatePrice(productCard, variant);
  updateCartButtons(productCard, variantId);
  updateProductUrl(productCard, product, variantId);
  updateProductImage(productCard, product, variant);

  updateSectionCartMap(previousVariantId, variantId);
}

function escapeHTML(str) {
  if (!str) return "";
  return str.replace(/[&<>"']/g, function (m) {
    return {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    }[m];
  });
}

function isProductAvailable(product, variant) {
  if (!product || !variant) return false;

  const status = product.status?.toUpperCase();

  return (
    status === "ACTIVE" &&
    variant.availableForSale === true
  );
}

function updateSectionAllToCartLink(sectionName, variantId) {

  // Initialize section if it doesn't exist
  if (!sections_add_to_cart_map[sectionName]) {
    sections_add_to_cart_map[sectionName] = {
      count: 0,
      cart_link: tangent_client_domain_url + "/cart/add?",
      list: []
    };
  }

  const sectionData = sections_add_to_cart_map[sectionName];

  // Prevent duplicate variant IDs
  if (!sectionData.list.includes(variantId)) {
    sectionData.count++;
    sectionData.cart_link += `&id[]=${variantId}`;
    sectionData.list.push(variantId);

    // Show "Add All to Cart" button if more than one product
    const addAllButton = document.getElementById(`${sectionName}_add_all_to_cart`);
    if (addAllButton) {
      addAllButton.style.display =
        sectionData.count > 1 ? "block" : "none";
    }
  }
}

function createFormDataFromIds(idArray) {
  return {
    items: idArray.map(id => ({
      id: id,
      quantity: 1
    }))
  };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([element.id]);
  addToCartApi(formData, element);
  
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(sections_add_to_cart_map["section_all_products"].list);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){

  // store original text once
  if (!element.dataset.defaultText) {
    element.dataset.defaultText = element.innerText;
  }

  // clear existing timer if user clicks again
  if (element.hideTimer) {
    clearTimeout(element.hideTimer);
  }

  // show loader
  element.classList.add("tangent-force-show");
  element.innerHTML = `<div class="loader button-loader"></div>`;
  element.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
  .then(() => {

    // success state
    element.innerText = "Added to Cart!";
    element.classList.add("added-to-cart-style");

    element.hideTimer = setTimeout(() => {

      // restore button
      element.innerText = element.dataset.defaultText;
      element.disabled = false;

      element.classList.remove("added-to-cart-style");
      element.classList.remove("tangent-force-show");

    }, 3000);

  })
  .catch((error) => {

    console.error('Error:', error);

    element.innerText = element.dataset.defaultText;
    element.disabled = false;
    element.classList.remove("tangent-force-show");

  });
}

function showOutOfStockMessage() {
  const messageEl = document.querySelector("#message-text");
  if (!messageEl) return;

  messageEl.textContent =
    "We're currently sold out of the selected product(s). Please check back later!";

  messageEl.classList.add("show");

  setTimeout(() => {
    messageEl.classList.remove("show");
  }, 5000);
}

const getVariantImage = (variantImage, product) => {

  let product_image;

  // 1. Variant image
  if (variantImage && variantImage.url) {
    product_image = variantImage.url;
  }

  // 2. Product main image
  else if (product?.images?.nodes?.length > 0) {
    product_image = product.images.nodes[0].url;
  }

  // 3. Default fallback image
  else {
    product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
  }

  return product_image;
};

// Main Section container 
function createSectionContainer(sectionName) {
  const sectionContainer = document.createElement("div");
  sectionContainer.id = `${sectionName}_container`;
  sectionContainer.classList.add("tangent_section_container");
  return sectionContainer;
}

function createSectionAddAllToCart(sectionName) {
  const button = document.createElement("button");

  button.id = `${sectionName}_add_all_to_cart`;
  button.type = "button"; // prevents form submission

  // Use the same classes that were on the <p>
  button.classList.add(
    "section_add_all_to_cart",
    `${sectionName}_add_all_to_cart`
  );

  button.textContent = default_add_all_to_cart_text;

  button.addEventListener("click", function () {
    addAllTocartFunction(this);
  });

  return button;
}

// Container having individual products
function addSectionProductGridContainer(sectionName) {
  const productGridViewContainer = document.createElement("div");

  productGridViewContainer.id = `${sectionName}_product_grid`;
  productGridViewContainer.classList.add(
    "section_product_grid",
    `${sectionName}_product_grid`
  );

  return productGridViewContainer;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
    }
}

function createTextSectionBeforeProducts(textSections, sectionContainer, sectionName) {
  const content = textSections?.[sectionName];

  if (!content || !Array.isArray(content)) return;

  const sectionDiv = document.createElement("div");
  sectionDiv.id = `${sectionName}_text_container`;
  sectionDiv.classList.add(
    "section_text_container",
    `${sectionName}_text_container`
  );

  sectionDiv.innerHTML = content.join(" ");
  sectionContainer.appendChild(sectionDiv);
}

// Section Text Creation (one without a product section)
function createTextSection(productSections, textSections) {
  const parentMap = {
    section_selfie: "#section_selfie_container_parent",
    section_blogs: "#section_blogs",
    section_disclaimer: "#section_disclaimer"
  };

  for (const [sectionName, content] of Object.entries(textSections || {})) {

    // Skip if already exists in product sections
    if (productSections?.[sectionName] !== undefined) continue;

    // Ensure content is valid
    if (!Array.isArray(content)) continue;

    const sectionContainer = createSectionContainer(sectionName);

    const sectionDiv = document.createElement("div");
    sectionDiv.id = `${sectionName}_text_container`;
    sectionDiv.classList.add("section_text_container", `${sectionName}_text_container`);
    sectionDiv.innerHTML = content.join(" ");

    sectionContainer.appendChild(sectionDiv);

    // Find parent element
    const parentSelector = parentMap[sectionName];
    const parent = parentSelector ? document.querySelector(parentSelector) : null;

    if (parent) {
      parent.appendChild(sectionContainer);
    }

    // Default fallback (when needed)
    // tangent_sections_wrapper_element?.appendChild(sectionContainer);
  }
}

function setTangentSelfieSection(response) {
  hideLoading();

  const imageElement = document.querySelector('#tangent_selfie_image');
  const containerElement = document.querySelector('#tangent_selfie_container');
  const htmlContainer = document.getElementById("tangent_selfie_image_container");
  
  if (response?.selfie_html) {
    htmlContainer.innerHTML = response.selfie_html;
    return;
  }

  if (response?.selfie_url) {
    imageElement.src = response.selfie_url;
    return;
  }
  else{
    imageElement.src = tangent_default_selfie_image_url;
    return;
  }
  containerElement.style.display = "flex";
  const hairTypes = ["straight", "wavy", "curly", "coily"];
  const tags = Array.isArray(response?.tags) ? response.tags : [];
  const detectedTypes = hairTypes.filter(type => tags.includes(type));

  if (detectedTypes.length > 0) {
    const matchedType = detectedTypes[0];
    const imageUrl = tangent_default_selfie_image_url;

    if (imageUrl) {
      imageElement.src = imageUrl;
    } else {
      console.warn(`No image URL found for detected hair type: ${matchedType}`);
    }
  } else {
    console.warn("No matching hair types detected in response tags.");
  }
}

function enableButtonListener() {
  const buttons = document.querySelectorAll('.tangent-product-add-btn-wrapper');

  buttons.forEach(button => {
    // Prevent duplicate listener attachment
    if (button.dataset.listenerAttached) return;

    button.addEventListener('click', function () {
      addToCart(this);
    });

    button.dataset.listenerAttached = "true";
  });
}

function openChatBot(){
  document.getElementById('reamaze-widget-icon')?.click();
}

function loadElementsOnResponseData() {
  const elements = document.querySelectorAll('.load-on-data');

  elements.forEach(element => {
    element.style.display = "block";
  });
}

// Hide loading
function hideLoading() {
  const loadingSection = document.querySelector("#loading-section");
  if (loadingSection) {
    loadingSection.style.display = "none";
  }
}

function setElementDisplay(elementId, display) {
  const element = document.getElementById(elementId);
  if (element) {
    element.style.display = display;
  }
}